import React from 'react';
import { View, Text } from 'react-native';
import moment from 'moment';
import { withRouter } from "react-router-dom";

import { CardTextArrow, Spacing } from "../../../components";
import { stringIsEmpty } from "../../../constants/StringChecker";
import CommentsIndicator from "../../mural/components/CommentsIndicator";

const TopicRender = (props) => {

    const { title, description, createdBy, createdAt, numberOfPosts, postSolutionId } = props.data;

    let icon = stringIsEmpty(postSolutionId) === true ? null : require('../../journeyStack/timeline/icons/checkIcon.png');

    return (
        <CardTextArrow
            iconSource={icon}
            iconStyle={{ height: 20, width: 20 }}
            text={title}
            showArrow={true}
            onPress={() => props.history.push("/forum/topic", { topicData: props.data })}
            containerStyle={{ marginBottom: 12 }}
        >

            <Text style={{ fontSize: 16, color: 'white' }}>
                { description }
            </Text>

            <Spacing height={6} />

            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text style={{ fontSize: 12, color: 'white' }}>
                    { `${createdBy} - ${moment(createdAt).format('DD/MM/YYYY - HH:mm:ss')}`  }
                </Text>

                <CommentsIndicator numberOfComments={numberOfPosts} />

            </View>

        </CardTextArrow >
    )
}

export default withRouter(TopicRender);
